import _ from 'lodash';

import { OFFLINE_TOKEN } from '../utils/constants';
import { Request } from '../utils/models';
import { storeItemInStorage } from '../utils/utilities';

export const addToQueue = async (request: Request): Promise<string> => {
	return new Promise((resolve) => {
		const queue: string[] = getQueue();
		const config = _.pick(request, ['url', 'method', 'data', 'headers']);

		queue.push(JSON.stringify(config));
		storeItemInStorage(OFFLINE_TOKEN, queue)

		setTimeout(() => {
			resolve('Action stored for sync when online');
		}, 3000);
	});
};

export const clearQueue = (): void => {
	localStorage.removeItem(OFFLINE_TOKEN);
};

export const getQueue = (): string[] => {
	const queue: string | null = localStorage.getItem(OFFLINE_TOKEN);
	if (!queue) return [];

	return JSON.parse(queue);
};
